<template>
  <header :class="$style.header">
    <BaseBack v-if="doShowBack" :class="$style.iconBox" @click.native="$router.push($route.params.parentPath || '/')"/>
    <div :class="$style.logoBox" @click="$router.push('/')">
      <!--      <SVGLogo height="32" width="32"/>-->
      <img :class="$style.image" src="@/assets/logo.png">
    </div>

    <div>
      <audio id="music" :src="musicData" autoplay="autoplay" loop="loop"/>
      <a id="audio_btn" :class="$style.logoBox" @click="onMusicClick">
        <img id="music_btn" class="music_rotation" src="@/assets/imgs/music.png" style="height:40px">
      </a>
    </div>
    <UserMenuList v-if="doShowMenuList" :onExit="() => {doShowMenuList = false}"/>
  </header>
</template>

<script>
import SVGLogo from '@/common/SVG/SVGLogo'
import BaseAvatar from '@/common/BaseAvatar'
import BaseMask from '@/common/BaseMask'
import BaseBack from '@/common/BaseBack'
// import UserMenuList from '@/components/User/UserMenuList'
// import { SIGNIN } from '@/components/User/module'
import { mapState } from 'vuex'
import { throttle } from '@/utils/util'
import { EventBus } from '@/utils/eventBus'

export default {
  components: {
    BaseAvatar,
    BaseMask,
    BaseBack,
    SVGLogo
  },
  data() {
    return {
      beta: '',
      doShowMenuList: false,
      musicData: 'https://manage.midmi.vip/media/music/2021/02/03/16123632877821345.mp3',
      doShowBack: false,
      autoPause: false,
      audioStatus: 1
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user
    })
  },
  watch: {
    $route(to, from) {
      console.log(`     ############header watch to: ${to.meta.index}, from:${from.meta.index}, audioStatus： ${this.audioStatus}`)
      this.doShowBack = to.meta.index > 1
      setTimeout(() => {
        if (this.autoPause) {
          this.onMusicClick()
          this.autoPause = false
        }
      }, 800)
    }
  },
  mounted() {
    // 自动登录
    this.autoLogin()
    // 监测陀螺仪
    window.addEventListener('deviceorientation', throttle(this.changeBeta))
    EventBus.$on('posts', ({ audio }) => {
      console.log(`     ############header audio: ${audio}, audioStatus： ${this.audioStatus}`)
      if (this.audioStatus > 0 && audio > 0) {
        setTimeout(() => {
          if (this.audioStatus > 0) {
            this.onMusicClick()
            this.autoPause = true
          }
        }, 1000)
      }
    })
  },
  beforeDestroy() {
    // 取消监测
    window.removeEventListener('deviceorientation', throttle(this.changeBeta))
  },
  methods: {
    autoLogin() {
      // const { commit } = this.$store
      // 如果storage中存在token，则使用storage中保存的信息进行自动登录
    },
    onUserClick() {
      // 如果当前用户已经登录，则弹出选择列表界面
      if (this.user) {
        this.doShowMenuList = true
      // 如果用户未登录，则显示登录页面
      } else {
        this.$router.push('/signin_by_username')
      }
    },
    changeBeta(e) {
      if (this.beta !== Math.round(e.beta)) {
        this.beta = Math.round(e.beta)
      }
    },
    onMusicClick() {
      const music = document.getElementById('music')
      const musicBtn = document.getElementById('music_btn')
      console.log(`onMusicClick clicked, ${music.paused}, audioStatus: ${this.audioStatus}`)
      if (music.paused) {
        music.play()
        // musicBtn.setAttribute(':class', '$style.music_rotation')
        musicBtn.className = 'music_rotation'
        this.audioStatus = 1
        this.autoPause = false
      } else {
        music.pause()
        // musicBtn.setAttribute(':class', '$style.music_normal')
        musicBtn.className = 'music_normal'
        this.audioStatus = 0
      }
    }
  }
}
</script>

<style module lang="postcss">
.header {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 4% 0 4%;
  background: #6c1888;
  background-size:contain;
  border-radius: 8px 8px 0 0;
}

.logoBox {
  height: 100%;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  overflow:hidden
}

.iconBox {
  height: 40px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  overflow:hidden
}

.image{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}

.title {
  display: inline-block;
  margin-left: 4px;
  font-size: 1.1em;
  background-image: linear-gradient(160deg, #7fdbff, #0074d9);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}

</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@-webkit-keyframes rotation{
  from {-webkit-transform: rotate(0deg);}
  to {-webkit-transform: rotate(360deg);}
}

.music_rotation{
  -webkit-transform: rotate(360deg);
  animation: rotation 3s linear infinite;
  -moz-animation: rotation 3s linear infinite;
  -webkit-animation: rotation 3s linear infinite;
  -o-animation: rotation 3s linear infinite;
}

.music_normal{
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader/TheHeader.vue